module.exports = __webpack_public_path__ + "static/National-Bold-09c520ebfcb7383f5ac2a52f80d28858.otf";